const systemMge = r => require.ensure([], () => r(require('@/page/systemMge/systemMge')), 'systemMge');
const roleMge = r => require.ensure([], () => r(require('@/page/systemMge/roleMge/roleMge')), 'roleMge');
const userMge = r => require.ensure([], () => r(require('@/page/systemMge/userMge/userMge')), 'userMge');
const right = r => require.ensure([], () => r(require('@/page/systemMge/JurisdictionMge/JurisdictionMge')), 'JurisdictionMge');
const feedback = r => require.ensure([],() => r(require('@/page/systemMge/feedback/feedback')),'feedback');
const dailyCleaning = r => require.ensure([],() => r(require('@/page/systemMge/dailyCleaning/dailyCleaning')),'dailyCleaning');
const dailyPatrol = r => require.ensure([],() => r(require('@/page/systemMge/dailyPatrol/dailyPatrol')),'dailyPatrol');

const systemRouter={
  path:'',
  name:'系统管理',
  component:systemMge,
  meta:{icon:'vote',right:[],isShowMenu:true,keepAlive:true},
  children:[
    {path:'roleMge',component:roleMge,name:'角色管理',meta: {right:[],isShowMenu:true,keepAlive:true},},
    {path:'userMge',component:userMge,name:'用户管理',meta: {right:[],isShowMenu:false,keepAlive:true},},
    {path:'/right',component:right,name:'权限管理',meta: {right: ['admin'],isShowMenu:false,keepAlive:true},},
    {path:'feedback',component:feedback,name:'意见反馈',meta: {right:[],isShowMenu:true,keepAlive:true},},
    {path:'dailyCleaning',component:dailyCleaning,name:'日常保洁',meta: {right:[],isShowMenu:true,keepAlive:true},},
    {path:'dailyPatrol',component:dailyPatrol,name:'日常巡逻',meta: {right:[],isShowMenu:true,keepAlive:true},},
  ]
};
export default systemRouter;